import { createContext, useContext } from "react";
import useAxios from "../Utils/useAxios";
import { openPdfInNewTab } from "../Utils/otherFunctions";
import {
  getItemSubmitSuccessMsg,
  getItemDeleteSuccessMsg,
  getItemCreateSuccessMsg,
  getItemEditSuccessMsg,
} from "../Constant/Message";
import { handleError, handleSuccess } from "../Utils/externalFunctions";

const TandaTerimaContext = createContext();

export const useTandaTerima = () => useContext(TandaTerimaContext);

export const TandaTerimaProvider = ({ children }) => {
  const axiosInstance = useAxios();

  const api = {
    getTandaTerima: () =>
      axiosInstance
        .get("tandaterima/tandaterima")
        .catch((err) => handleError(err, "GET Tanda Terima")),

    getYangMenyerahkan: (id) =>
      axiosInstance
        .get(`tandaterima/tandaterima/${id}/yang-menyerahkan`)
        .catch((err) => handleError(err, "GET Yang Menyerahkan")),

    getPenerima: (id) =>
      axiosInstance
        .get(`tandaterima/tandaterima/${id}/penerima`)
        .catch((err) => handleError(err, "GET Penerima")),

    getPemberiTugas: (id) =>
      axiosInstance
        .get(`tandaterima/tandaterima/${id}/pemberi-tugas`)
        .catch((err) => handleError(err, "GET Pemberi Tugas")),

    getUnitKerja: () =>
      axiosInstance
        .get("sipeg/unitkerja/")
        .catch((err) => handleError(err, "GET Unit Kerja")),

    getKurir: () =>
      axiosInstance
        .get(`tandaterima/kurir/`)
        .catch((err) => handleError(err, "GET Kurir")),

    getTandaTerimaKurir: (username) =>
      axiosInstance
        .post("tandaterima/tandaterima/kurir/", { username: username })
        .catch((err) => handleError(err, "GET Tanda Terima")),

    getTandaTerimaCetak: (id, toggle) =>
      axiosInstance
        .get(`tandaterima/tandaterima/cetak/${id}`, {
          responseType: "blob",
        })
        .then((res) => {
          if (toggle) toggle();
          openPdfInNewTab(res);
          return handleSuccess(res, getItemCreateSuccessMsg("Tanda Terima"));
        })
        .catch((err) => handleError(err, "POST Tanda Terima")),

    getBuktiTandaTerimaCetak: (id, toggle) =>
      axiosInstance
        .get(`tandaterima/bukti/${id}`, {
          responseType: "blob",
        })
        .then((res) => {
          if (toggle) toggle();
          openPdfInNewTab(res);
          return handleSuccess(
            res,
            getItemCreateSuccessMsg("Bukti Tanda Terima")
          );
        })
        .catch((err) => handleError(err, "POST Bukti Tanda Terima")),

    createTandaTerima: (formData) =>
      axiosInstance
        .post("tandaterima/tandaterima/", formData)
        .then((res) =>
          handleSuccess(res, getItemSubmitSuccessMsg("Tanda Terima"))
        )
        .catch((err) => handleError(err, "POST Tanda Terima")),

    createBuktiTandaTerima: (formData, id) =>
      axiosInstance
        .post(`tandaterima/bukti/${id}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) =>
          handleSuccess(res, getItemSubmitSuccessMsg("Bukti Tanda Terima"))
        )
        .catch((err) => handleError(err, "POST Bukti Tanda Terima")),

    updateTandaTerima: (id, formData) =>
      axiosInstance
        .put(`tandaterima/tandaterima/${id}`, formData)
        .then((res) =>
          handleSuccess(res, getItemEditSuccessMsg("Tanda Terima"))
        )
        .catch((err) => handleError(err, "PUT Tanda Terima")),

    updateYangMenyerahkanSign: (id, signData) =>
      axiosInstance
        .post(`tandaterima/yang-menyerahkan/${id}/sign/`, signData)
        .then((res) =>
          handleSuccess(res, "Tanda tangan yang menyerahkan berhasil disimpan")
        )
        .catch((err) =>
          handleError(err, "Gagal menyimpan tanda tangan yang menyerahkan: ")
        ),

    updatePenerimaSign: (id, signData) =>
      axiosInstance
        .put(`tandaterima/penerima/${id}/sign/`, signData)
        .then((res) =>
          handleSuccess(res, "Tanda tangan penerima berhasil disimpan")
        )
        .catch((err) =>
          handleError(err, "Gagal menyimpan tanda tangan penerima: ")
        ),

    updatePemberiTugasSign: (id, signData) =>
      axiosInstance
        .put(`tandaterima/pemberi-tugas/${id}/sign/`, signData)
        .then((res) =>
          handleSuccess(res, "Tanda tangan pemberi tugas berhasil disimpan")
        )
        .catch((err) =>
          handleError(err, "Gagal menyimpan tanda tangan pemberi tugas: ")
        ),

    deleteTandaTerima: (id) =>
      axiosInstance
        .delete(`tandaterima/tandaterima/${id}`)
        .then((res) =>
          handleSuccess(res, getItemDeleteSuccessMsg("Tanda Terima"))
        )
        .catch((err) => handleError(err, "DELETE Tanda Terima")),

    getLocationFromCoords: async (latitude, longitude) => {
      try {
        const response = await fetch(
          `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
        );
        const data = await response.json();

        if (data) {
          const city =
            data.address?.city ||
            data.address?.town ||
            data.address?.village ||
            data.address?.municipality;
          const province = data.address?.state;
          const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

          return {
            city,
            province,
            url: googleMapsUrl,
          };
        }
        return null;
      } catch (error) {
        console.error("Error getting location:", error);
        return null;
      }
    },
  };

  return (
    <TandaTerimaContext.Provider value={api}>
      {children}
    </TandaTerimaContext.Provider>
  );
};

export default TandaTerimaContext;
